import Vue from 'vue'
import Vuex from 'vuex'
import { getSubjects, getSubjectByPid, getAuthInfo, getAccountInfo } from '@/api'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: null,
    isLogin: false,
    subjectId: null,
    subjectName: '',
    menuId: null,
    enterMode: 'exam', // 'exam' or 'bank'
    searchQuestions: [],
    host: 'https://akt.yifeng2016.com',
    subjects: [],
    practiceStatistic: null,
    practiceLatest: null
  },
  mutations: {
    SET_USER_INFO(state, info) {
      state.userInfo = info
      state.isLogin = !!info
    },
    SET_LOGIN(state, status) {
      state.isLogin = status
    },
    SET_SUBJECT_ID(state, id) {
      state.subjectId = id
    },
    SET_SUBJECT_NAME(state, name) {
      state.subjectName = name
    },
    SET_MENU_ID(state, id) {
      state.menuId = id
    },
    SET_ENTER_MODE(state, mode) {
      state.enterMode = mode
    },
    SET_SEARCH_QUESTIONS(state, questions) {
      state.searchQuestions = questions
    },
    SET_SUBJECTS(state, subjects) {
      state.subjects = subjects
    },
    SET_PRACTICE_STATISTIC(state, data) {
      state.practiceStatistic = data
    },
    SET_PRACTICE_LATEST(state, data) {
      state.practiceLatest = data
    },
    SAVE_CURRENT_SUBJECT(state, { id, name }) {
      state.subjectId = id
      state.subjectName = name
      localStorage.setItem('subjectId', id)
      localStorage.setItem('subjectName', name)
    }
  },
  actions: {
    async fetchSubjects({ commit }) {
      try {
        const data = await getSubjects()
        if (Array.isArray(data)) {
          commit('SET_SUBJECTS', data)
        }
        return Array.isArray(data) ? data : []
      } catch (e) {
        console.error('获取科目失败:', e)
      }
    },
    async fetchSubjectByPid({ commit }, { pid, menuId }) {
      try {
        const data = await getSubjectByPid(pid, menuId)
        return Array.isArray(data) ? data : []
      } catch (e) {
        console.error('获取子科目失败:', e)
        return []
      }
    },
    async fetchAuthInfo({ commit }) {
      try {
        const data = await getAuthInfo()
        if (data && typeof data === 'object') {
          commit('SET_USER_INFO', data)
        }
      } catch (e) {
        console.error('获取用户信息失败:', e)
      }
    },
    async fetchAccountInfo({ commit }) {
      try {
        const data = await getAccountInfo()
        if (data && typeof data === 'object') {
          commit('SET_USER_INFO', data)
          return data
        }
        return null
      } catch (e) {
        console.error('获取账户信息失败:', e)
        commit('SET_LOGIN', false)
        commit('SET_USER_INFO', null)
        return null
      }
    },
    saveCurrentSubject({ commit }, { id, name }) {
      commit('SAVE_CURRENT_SUBJECT', { id, name })
    },
    initDefaultSubject({ state, commit }) {
      const savedId = localStorage.getItem('subjectId')
      const savedName = localStorage.getItem('subjectName')
      if (savedId && savedName) {
        commit('SET_SUBJECT_ID', savedId)
        commit('SET_SUBJECT_NAME', savedName)
      }
    }
  }
})
